export const CAREER_ACTS = [
  {
    year: "Act I",
    title: "Business judgment before code",
    text: "Seven years in analytical finance and a Finance BBA from Baruch taught me to question assumptions, weigh trade-offs, and connect decisions to business outcomes. I bring that same lens to engineering: understand the problem, then build what matters.",
  },
  {
    year: "Act II",
    title: "From training to founder partnership",
    text: "After Per Scholas / General Assembly, I worked directly with company owners at Frogshop and JR Solutions. At Frogshop, I led four developers and built white-label onboarding services that cut onboarding time by 20%. At JR Solutions, targeted campaigns lifted international engagement by 27% and click-through rates by 15%.",
  },
  {
    year: "Act III",
    title: "AI in the production workflow",
    text: "Seven years at Fubo, since July 2019. I architected and deployed a real-time React / TypeScript / Node dashboard with an OpenAI-powered classifier to categorize tickets and reduce manual triage. Alongside it, I built geolocation tooling that brought resolution from minutes to seconds and experimentation tools that cut setup from days to hours.",
  },
  {
    year: "Act IV",
    title: "Giving AI tools to act",
    text: "Beyond model responses: I built a custom MCP server used with Claude and implemented tool-calling patterns that connect AI to software actions. I standardized Cursor-assisted test scaffolding, refactoring, and reviewable iteration—bringing engineering discipline to AI-assisted delivery.",
  },
];
